import React from 'react';
import { Modal } from 'rsuite';
import { AllegroResponsibleProducer } from '../../../../api/allegro/responsibleproducer/responsibleProducerTypes';
import EshopSetupAllegroResponsibleProducerEdit from './EshopSetupAllegroResponsibleProducerEdit';

const EDIT_TITLE = 'Edit responsible producer';
const CREATE_TITLE = 'Create responsible producer';

interface Props {
  isOpen: boolean;
  marketplaceCode: string;
  responsibleProducer?: AllegroResponsibleProducer;
  onClose: () => void;
  onSaved: () => void;
}

export default function EshopSetupAllegroResponsibleProducerEditModal({
  isOpen,
  marketplaceCode,
  responsibleProducer,
  onClose,
  onSaved,
}: Props): JSX.Element {
  const title = responsibleProducer ? EDIT_TITLE : CREATE_TITLE;

  return (
    <Modal
      open={isOpen}
      onClose={() => onClose()}
      backdrop="static"
      overflow
    >
      <Modal.Header>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EshopSetupAllegroResponsibleProducerEdit
          marketplaceCode={marketplaceCode}
          responsibleProducer={responsibleProducer}
          onCancel={() => onClose()}
          onSaved={() => onSaved()}
        />
      </Modal.Body>
    </Modal>
  );
}

EshopSetupAllegroResponsibleProducerEditModal.defaultProps = {
  responsibleProducer: undefined,
};
